import { render } from "./PostListCommentInput.vue?vue&type=template&id=3ef29420"
import script from "./PostListCommentInput.vue?vue&type=script&lang=js"
export * from "./PostListCommentInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__